module.exports = __webpack_public_path__ + "img/cafe-leche.265ee2b7.jpg";